import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { getEffectiveUtm, pickUtmFromQuery, type UtmParams } from "utils/utm-storage";

/**
 * Returns the effective UTM params for the current page. Seeds from the URL
 * query (SSR-safe, no hydration mismatch) and merges sessionStorage fallbacks
 * after mount so forms keep attribution after navigating to a clean URL.
 */
const useUtmParams = (): UtmParams => {
    const { query } = useRouter();
    const [utm, setUtm] = useState<UtmParams>(() => pickUtmFromQuery(query));

    useEffect(() => {
        setUtm(getEffectiveUtm(query));
    }, [query]);

    return utm;
};

export default useUtmParams;
